import React, { useMemo } from 'react';
import {
  Card,
  Stack,
  useTheme,
} from '@mui/material';
import {
  ProfileCardContent,
  LabelAndValueElement,
  useApiClient,
  useFetchImmutable,
} from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { OfficeCardProps } from '../types';
import { getPartnerOfficePhoneNumber } from '../../../../utils/helpers';
import stylesT from '../styles';

const OfficeCard = ({
  office,
}: OfficeCardProps) => {
  const theme = useTheme();
  const styles = stylesT(theme);
  const apiClient = useApiClient();
  const { data: countryCodes } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);

  const officeCountry = useMemo(() => {
    if (!countryCodes) {
      return '-';
    }
    if (!office || !office.country) {
      return '-';
    }
    return countryCodes[office.country];
  }, [office, countryCodes]);

  return (
    <Card sx={styles.profileCard}>
      <ProfileCardContent>
        <Stack spacing="24px" width="100%">
          <LabelAndValueElement
            title="City"
            value={office?.city || '-'}
            key="city"
          />
          <LabelAndValueElement
            title="Country"
            value={officeCountry}
            key="country"
          />
          <LabelAndValueElement
            title="Phone"
            value={getPartnerOfficePhoneNumber(office)}
            key="phone"
          />
        </Stack>
      </ProfileCardContent>
    </Card>
  );
};

export default OfficeCard;
